var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card-header text-center border-bottom-0" }, [
      _c("h1", { staticClass: "h4" }, [
        _vm._v(_vm._s(_vm.$t("design.typography")))
      ])
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "form form-lines" }, [
        _c("p", { staticClass: "border-bottom pb-2" }, [
          _c("em", [_vm._v("$baseFont")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "base_title big" }, [_c("span")]),
        _vm._v(" "),
        _c("p", { staticClass: "medium" }, [
          _vm._v('abcdefghijklmnñopqrstuvwxyz1234567890!!"·$%&/()=')
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "medium" }, [
          _vm._v("ABCDEFGHIJKLMNÑOPQRSTUVWXYZ")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam doloribus porro nulla provident suscipit alias ullam, debitis ea odio aperiam quod rem cum, molestias temporibus maxime quisquam eius. Laboriosam, laudantium."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("Lorem "),
          _c("strong", [_vm._v("ipsum dolor sit amet")]),
          _vm._v(", "),
          _c("em", [_vm._v("consectetur adipisicing elit")]),
          _vm._v(
            ". In, voluptas deleniti quae, alias mollitia natus dolor voluptatem iste facere inventore ad sequi nulla aut quo fugiat eveniet numquam pariatur nesciunt."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "border-bottom pb-2 mt-4 pt-4" }, [
          _c("em", [_vm._v("$titleFont")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "title_title big title_font" }, [_c("span")]),
        _vm._v(" "),
        _c("p", { staticClass: "medium title_font" }, [
          _vm._v('abcdefghijklmnñopqrstuvwxyz1234567890!!"·$%&/()=')
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "medium title_font" }, [
          _vm._v("ABCDEFGHIJKLMNÑOPQRSTUVWXYZ")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam doloribus porro nulla provident suscipit alias ullam, debitis ea odio aperiam quod rem cum, molestias temporibus maxime quisquam eius. Laboriosam, laudantium."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("Lorem "),
          _c("strong", [_vm._v("ipsum dolor sit amet")]),
          _vm._v(", "),
          _c("em", [_vm._v("consectetur adipisicing elit")]),
          _vm._v(
            ". In, voluptas deleniti quae, alias mollitia natus dolor voluptatem iste facere inventore ad sequi nulla aut quo fugiat eveniet numquam pariatur nesciunt."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Styles/Typography.vue?vue&type=template&id=dd10571e&scoped=true&
// module id = null
// module chunks = 